/* ==========================================================================
   REAPER — Unified Product Section behaviour  (reaper-product.js)
   One component for single / bundle / licked modes. Prices in PENCE.
   Replaces product-bundle-single.js + product-bundle-dual.js.
   ========================================================================== */
(function () {
  'use strict';

  var data = window.rpData || {};
  var variants = data.variants || [];
  var mode = data.mode || 'single';
  var SYM = data.moneySymbol || '£';

  var root = document.querySelector('[data-rp]');
  if (!root) return;

  /* ---------- helpers ---------- */
  function money(pence) {
    if (pence == null || isNaN(pence)) return '—';
    return SYM + (pence / 100).toFixed(2);
  }
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
  function show(id, on) { var el = document.getElementById(id); if (el) el.hidden = !on; }

  /* ---------- element refs ---------- */
  var atcBtn = document.getElementById('rp-atc');
  var stickyBtn = document.getElementById('rp-sticky-atc');
  var stickyEl = document.getElementById('rp-sticky');
  var mainImg = document.getElementById('rp-main-img');
  var dynamicId = document.getElementById('rp-dynamic-id');

  /* ---------- selected-variant resolution (generic options) ---------- */
  var selected = []; // option values by index

  function initSelected() {
    $all('.rp-opt:not([data-tub])').forEach(function (opt) {
      var idx = parseInt(opt.getAttribute('data-option-index'), 10);
      var active = $('.rp-swatch.is-active', opt);
      selected[idx] = active ? active.getAttribute('data-value') : null;
    });
    if (!selected.length && variants[0]) selected = variants[0].options.slice();
  }

  function matchVariant() {
    if (!selected.length) return variants[0] || null;
    return variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    }) || null;
  }

  /* ---------- render price / state for single & bundle ---------- */
  function computeSave(variant) {
    if (mode === 'bundle' && data.rrpPence) {
      return Math.max(0, data.rrpPence - variant.price);
    }
    if (variant.compareAt && variant.compareAt > variant.price) {
      return variant.compareAt - variant.price;
    }
    return 0;
  }

  function updateState() {
    var v = matchVariant();
    if (!v) {
      setText('rp-price-now', '—');
      if (atcBtn) { atcBtn.disabled = true; atcBtn.querySelector('.rp-atc__label').textContent = 'Unavailable'; }
      return;
    }

    var save = computeSave(v);
    var wasPence = (mode === 'bundle' && data.rrpPence) ? data.rrpPence : v.compareAt;

    setText('rp-price-now', money(v.price));
    setText('rp-sticky-price', money(v.price));

    var wasEl = document.getElementById('rp-price-was');
    if (wasEl) {
      if (wasPence && wasPence > v.price) { wasEl.textContent = money(wasPence); wasEl.hidden = false; }
      else { wasEl.hidden = true; }
    }
    var saveEl = document.getElementById('rp-price-save');
    if (saveEl) {
      if (save > 0) { saveEl.textContent = 'Save ' + money(save); saveEl.hidden = false; }
      else { saveEl.hidden = true; }
    }
    setText('rp-bundle-save', money(save));

    var priceTag = document.getElementById('rp-atc-price');
    if (priceTag) priceTag.textContent = save > 0 ? '· Save ' + money(save) : '';

    // availability
    [atcBtn, stickyBtn].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = !v.available;
      btn.setAttribute('data-variant-id', v.id);
      var label = btn.querySelector('.rp-atc__label');
      if (label) label.textContent = v.available ? 'Add to Bag' : 'Sold Out';
    });
    if (dynamicId) dynamicId.value = v.id;

    // image swap to variant image
    if (v.image && mainImg && mainImg.src !== v.image) swapImage(v.image);
  }

  /* ---------- option swatches (variant picker; excludes bundle tub pickers) ---------- */
  $all('.rp-opt:not([data-tub])').forEach(function (opt) {
    var idx = parseInt(opt.getAttribute('data-option-index'), 10);
    opt.addEventListener('click', function (e) {
      var btn = e.target.closest('.rp-swatch');
      if (!btn || btn.classList.contains('is-unavailable')) return;
      $all('.rp-swatch', opt).forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      selected[idx] = btn.getAttribute('data-value');
      var lbl = opt.querySelector('.rp-opt__value');
      if (lbl) lbl.textContent = selected[idx];
      updateState();
    });
  });

  /* ---------- bundle per-tub flavour pickers (saved as line-item properties) ---------- */
  $all('.rp-opt[data-tub]').forEach(function (opt) {
    opt.addEventListener('click', function (e) {
      var btn = e.target.closest('.rp-swatch');
      if (!btn) return;
      $all('.rp-swatch', opt).forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var lbl = opt.querySelector('.rp-opt__value');
      if (lbl) lbl.textContent = btn.getAttribute('data-value');
    });
  });
  function tubProps() {
    var props = {};
    $all('.rp-opt[data-tub]').forEach(function (t) {
      var key = t.getAttribute('data-prop');
      var act = t.querySelector('.rp-swatch.is-active');
      if (key && act) props[key] = act.getAttribute('data-value');
    });
    return props;
  }
  function bundleVariant() {
    var t0 = document.querySelector('.rp-opt[data-tub] .rp-swatch.is-active');
    var first = t0 ? t0.getAttribute('data-value') : null;
    if (first) {
      var m = variants.find(function (v) { return v.available && v.options.indexOf(first) !== -1; });
      if (m) return m;
    }
    return variants.find(function (v) { return v.available; }) || variants[0] || null;
  }

  /* ---------- gallery ---------- */
  function swapImage(src) {
    if (!mainImg) return;
    mainImg.classList.add('is-switching');
    var pre = new Image();
    pre.onload = function () { mainImg.src = src; mainImg.classList.remove('is-switching'); };
    pre.src = src;
  }
  $all('.rp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-src');
      if (!src) return;
      $all('.rp-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      swapImage(src);
    });
  });

  /* ---------- quantity (single) ---------- */
  var qtyInput = document.getElementById('rp-qty');
  function getQty() { return Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1); }
  var qm = document.getElementById('rp-qty-minus');
  var qp = document.getElementById('rp-qty-plus');
  if (qm) qm.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, getQty() - 1); });
  if (qp) qp.addEventListener('click', function () { if (qtyInput) qtyInput.value = getQty() + 1; });
  if (qtyInput) qtyInput.addEventListener('change', function () { this.value = Math.max(1, parseInt(this.value, 10) || 1); });

  /* ---------- licked multi-tub ---------- */
  var lickedWrap = document.querySelector('[data-rp-licked]');
  var lickedQtys = {};
  var lickedMax = data.lickedMax || 2;
  var unitPence = variants[0] ? variants[0].price : 0;

  function lickedTotal() {
    return Object.keys(lickedQtys).reduce(function (s, k) { return s + lickedQtys[k]; }, 0);
  }
  function refreshLicked() {
    variants.forEach(function (v) {
      var el = document.getElementById('rp-lq-' + v.id);
      if (el) el.textContent = lickedQtys[v.id] || 0;
    });
    $all('.rp-step-btn[data-action=plus]', lickedWrap).forEach(function (b) { b.disabled = lickedTotal() >= lickedMax; });
    $all('.rp-step-btn[data-action=minus]', lickedWrap).forEach(function (b) {
      var vid = b.getAttribute('data-variant'); b.disabled = (lickedQtys[vid] || 0) <= 0;
    });
    var total = lickedTotal() * unitPence;
    setText('rp-price-now', money(total || unitPence));
    setText('rp-sticky-price', money(total || unitPence));
    if (atcBtn) {
      atcBtn.disabled = lickedTotal() < 1;
      var lbl = atcBtn.querySelector('.rp-atc__label');
      if (lbl) lbl.textContent = lickedTotal() > 1 ? 'Add ' + lickedTotal() + ' Tubs to Bag' : 'Add to Bag';
    }
  }
  if (lickedWrap) {
    // default: 1 tub of first available flavour
    var firstAvail = variants.find(function (v) { return v.available; });
    if (firstAvail) lickedQtys[firstAvail.id] = 1;
    lickedWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.rp-step-btn');
      if (!btn) return;
      var vid = btn.getAttribute('data-variant');
      var action = btn.getAttribute('data-action');
      if (action === 'plus' && lickedTotal() < lickedMax) lickedQtys[vid] = (lickedQtys[vid] || 0) + 1;
      if (action === 'minus' && (lickedQtys[vid] || 0) > 0) lickedQtys[vid] -= 1;
      refreshLicked();
    });
  }

  /* ---------- add to cart ---------- */
  function itemsToAdd() {
    if (mode === 'licked') {
      return variants.filter(function (v) { return (lickedQtys[v.id] || 0) > 0; })
        .map(function (v) { return { id: v.id, quantity: lickedQtys[v.id] }; });
    }
    if (mode === 'bundle') {
      var props = tubProps();
      if (Object.keys(props).length) {
        var bv = bundleVariant();
        if (!bv) return [];
        return [{ id: bv.id, quantity: getQty(), properties: props }];
      }
      /* no per-tub pickers: fall through to normal variant matching (e.g. Full Stack flavour) */
    }
    var v = matchVariant();
    if (!v) return [];
    return [{ id: v.id, quantity: getQty() }];
  }

  function openCart() {
    ['cart:refresh', 'cart:updated', 'theme:cart:open'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
    });
    // best-effort drawer open for Horizon-style cart components
    var drawer = document.querySelector('cart-drawer-component, cart-drawer, [ref=cartDrawer]');
    if (drawer) {
      if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
      if (typeof drawer.showModal === 'function') { try { drawer.showModal(); return; } catch (e) {} }
      drawer.setAttribute('open', '');
    }
  }

  function flash(btn, ok) {
    if (!btn) return;
    var label = btn.querySelector('.rp-atc__label');
    var original = label ? label.textContent : btn.textContent;
    btn.classList.toggle('is-added', ok);
    if (label) label.textContent = ok ? 'Added ✓' : 'Try again';
    setTimeout(function () {
      btn.classList.remove('is-added');
      if (label) label.textContent = original;
      btn.disabled = false;
    }, 2200);
  }

  function doAtc(btn) {
    var items = itemsToAdd();
    if (!items.length) return;
    btn.disabled = true;
    var label = btn.querySelector('.rp-atc__label');
    if (label) label.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { flash(btn, true); openCart(); })
      .catch(function () { flash(btn, false); });
  }

  if (atcBtn) atcBtn.addEventListener('click', function () { doAtc(atcBtn); });
  if (stickyBtn) stickyBtn.addEventListener('click', function () { doAtc(stickyBtn); });

  /* ---------- sticky bar ---------- */
  if (stickyEl && atcBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      stickyEl.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    io.observe(atcBtn);
  }

  /* ---------- init ---------- */
  initSelected();
  if (mode === 'licked') { refreshLicked(); } else { updateState(); }
})();

/* ==========================================================================
   Dynamic delivery estimate — DHL next-day, UK only, Mon-Fri, midday cutoff.
   Before 12:00 UK on a weekday: counts down to same-day dispatch / next-day
   delivery. Otherwise: shows the next available delivery day.
   ========================================================================== */
(function () {
  'use strict';
  var el = document.querySelector('.rp-delivery');
  if (!el || typeof Intl === 'undefined') return;
  var TRUCK = '<svg class="rp-i" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';

  function ukParts() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour: '2-digit', minute: '2-digit', second: '2-digit', year: 'numeric', month: '2-digit', day: '2-digit', hour12: false });
    var p = {};
    f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return p;
  }
  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function isWeekend(d) { var g = d.getDay(); return g === 0 || g === 6; }
  function nextBiz(d) { var x = addDays(d, 1); while (isWeekend(x)) { x = addDays(x, 1); } return x; }

  function render() {
    var p = ukParts();
    var hh = parseInt(p.hour, 10) % 24, mm = parseInt(p.minute, 10), ss = parseInt(p.second, 10);
    var base = new Date(parseInt(p.year, 10), parseInt(p.month, 10) - 1, parseInt(p.day, 10));
    var isWeekday = base.getDay() >= 1 && base.getDay() <= 5;
    var secs = hh * 3600 + mm * 60 + ss;
    var eligible = isWeekday && secs < 43200; /* before 12:00 */
    var dispatch = eligible ? new Date(base.getTime()) : nextBiz(base);
    var delivery = nextBiz(dispatch);
    var isTomorrow = delivery.toDateString() === addDays(base, 1).toDateString();
    var label = isTomorrow ? 'tomorrow' : delivery.toLocaleDateString('en-GB', { weekday: 'long' });
    var msg;
    if (eligible) {
      var left = 43200 - secs, h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
      var cd = (h > 0 ? h + 'h ' : '') + m + 'm ' + s + 's';
      msg = 'Get it <strong>' + label + '</strong> — order within <strong>' + cd + '</strong> · DHL next-day, UK';
    } else {
      msg = 'Order now for <strong>' + label + '</strong> delivery · DHL next-day, UK';
    }
    el.innerHTML = TRUCK + ' <span>' + msg + '</span>';
  }
  render();
  setInterval(render, 1000);
})();
